import { __awaiter, __decorate, __metadata } from "tslib";
import { inject, injectable } from 'mana-syringe';
import { ICommandHandler, ICommandContextProvider } from '../../command/interface';
import { XFlowGroupCommands } from '../constant';
import { Disposable } from '../../common/disposable';
import { XFlowNodeCommands } from '../constant';
export var NsAddGroup;
(function (NsAddGroup) {
    /** Command: 用于注册named factory */
    NsAddGroup.command = XFlowGroupCommands.ADD_GROUP;
    /** hookName */
    NsAddGroup.hookKey = 'addGroup';
    NsAddGroup.GROUP_PADDING = 12;
    NsAddGroup.GROUP_HEADER_HEIGHT = 40;
})(NsAddGroup || (NsAddGroup = {}));
let AddGroupCommand = 
/** 创建节点命令 */
class AddGroupCommand {
    constructor() {
        this.getBBox = (node, nodeConfig, graph) => {
            const { groupHeaderHeight = NsAddGroup.GROUP_HEADER_HEIGHT, groupPadding = NsAddGroup.GROUP_PADDING, } = nodeConfig;
            const bbox = graph.getCellsBBox(node.children);
            bbox.moveAndExpand({
                x: -groupPadding,
                y: -(groupPadding + groupHeaderHeight),
                width: groupPadding * 2,
                height: groupPadding * 2 + groupHeaderHeight,
            });
            return bbox;
        };
        /** 执行Cmd */
        this.execute = () => __awaiter(this, void 0, void 0, function* () {
            const ctx = this.contextProvider();
            const { args, hooks: runtimeHook } = ctx.getArgs();
            const hooks = ctx.getHooks();
            const result = yield hooks.addGroup.call(args, (handlerArgs) => __awaiter(this, void 0, void 0, function* () {
                const { nodeConfig, createService: createGroupService, cellFactory, commandService, } = handlerArgs;
                const graph = yield ctx.getX6Graph();
                const res = yield commandService.executeCommand(XFlowNodeCommands.ADD_NODE.id, {
                    cellFactory,
                    createNodeService: createGroupService,
                    nodeConfig,
                });
                const { nodeCell: groupCell } = res
                    .contextProvider()
                    .getResult();
                const { id: groupId } = groupCell;
                const { groupChildren } = nodeConfig;
                if (groupChildren.length) {
                    groupChildren.forEach(nodeId => {
                        const child = graph.getCellById(nodeId);
                        if (child) {
                            child.setData(Object.assign(Object.assign({}, child.getData()), { group: groupId, isCollapsed: false }));
                            child.prop('group', groupId);
                            groupCell.addChild(child);
                            graph.unselect(child);
                        }
                    });
                    const groupBBox = this.getBBox(groupCell, nodeConfig, graph);
                    groupCell.position(groupBBox.x, groupBBox.y);
                    groupCell.size(groupBBox.width, groupBBox.height);
                    groupCell.setZIndex(0);
                    groupCell.prop('isGroup', true);
                    groupCell.setData(Object.assign(Object.assign({}, groupCell.getData()), { width: groupBBox.width, height: groupBBox.height, groupChildrenSize: { width: groupBBox.width, height: groupBBox.height }, x: groupBBox.x, y: groupBBox.y, isGroup: true }));
                    graph.select(groupCell);
                }
                if (nodeConfig.isCollapsed) {
                    yield commandService.executeCommand(XFlowGroupCommands.COLLAPSE_GROUP.id, {
                        nodeId: nodeConfig.id,
                        isCollapsed: nodeConfig.isCollapsed,
                    });
                }
                /** add undo: delete node */
                ctx.addUndo(Disposable.create(() => __awaiter(this, void 0, void 0, function* () {
                    commandService.executeCommand(XFlowGroupCommands.DEL_GROUP.id, {
                        nodeConfig,
                    });
                })));
                return { nodeConfig: nodeConfig, nodeCell: groupCell };
            }), runtimeHook);
            ctx.setResult(result);
            return this;
        });
        /** undo cmd */
        this.undo = () => __awaiter(this, void 0, void 0, function* () {
            const ctx = this.contextProvider();
            if (this.isUndoable()) {
                ctx.undo();
            }
            return this;
        });
        /** redo cmd */
        this.redo = () => __awaiter(this, void 0, void 0, function* () {
            if (!this.isUndoable()) {
                yield this.execute();
            }
            return this;
        });
    }
    isUndoable() {
        const ctx = this.contextProvider();
        return ctx.isUndoable();
    }
};
__decorate([
    inject(ICommandContextProvider),
    __metadata("design:type", Object)
], AddGroupCommand.prototype, "contextProvider", void 0);
AddGroupCommand = __decorate([
    injectable({
        token: { token: ICommandHandler, named: NsAddGroup.command.id },
    })
    /** 创建节点命令 */
], AddGroupCommand);
export { AddGroupCommand };
//# sourceMappingURL=group-add.js.map